module.exports = __webpack_public_path__ + "static/media/rules-puzzle-complete.5c290d24.png";